import { render, staticRenderFns } from "./recategorize_domain.vue?vue&type=template&id=17c2cb79&"
import script from "./recategorize_domain.vue?vue&type=script&lang=js&"
export * from "./recategorize_domain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./recategorize_domain.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports